import React from 'react';
import {
  Box,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Typography,
  Paper
} from '@mui/material';
import { Search, FilterList, ExpandMore } from '@mui/icons-material';

const JobFilter = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  typeFilter,
  setTypeFilter,
  statusTypes = [],
  jobTypes = [],
  expandedFilters,
  setExpandedFilters,
  statusColors = {}
}) => {
  return (
    <Paper
      elevation={3}
      sx={{
        m: 2,
        p: 2,
        borderRadius: 3,
        backgroundColor: '#fff',
        transition: 'box-shadow 0.3s ease-in-out',
        boxShadow: 3,
        '&:hover': {
          boxShadow: 6,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="h5"
          color="primary"
          fontFamily="Roboto, sans-serif"
          fontWeight={600}
        >
          Job Logs Analysis
        </Typography>

        <IconButton
          onClick={() => setExpandedFilters(!expandedFilters)}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            color: 'primary.main',
            transition: 'background-color 0.2s',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.1)', // light primary hover
            }
          }}
        >
          <FilterList fontSize="small" />
          <ExpandMore
            sx={{
              transform: expandedFilters ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
              ml: 0.5
            }}
          />
        </IconButton>
      </Box>

      {expandedFilters && (
        <>
          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search jobs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search color="primary" />
                    </InputAdornment>
                  )
                }}
                sx={{
                  '& .MuiOutlinedInput-root:hover': {
                    '& fieldset': {
                      borderColor: 'primary.main',
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  label="Status"
                  sx={{
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <MenuItem value="all">All Statuses</MenuItem>
                  {statusTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      <Box display="flex" alignItems="center">
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            bgcolor: statusColors[type] || 'grey.500',
                            mr: 1
                          }}
                        />
                        {type}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Type</InputLabel>
                <Select
                  value={typeFilter}
                  onChange={(e) => setTypeFilter(e.target.value)}
                  label="Type"
                  sx={{
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <MenuItem value="all">All Types</MenuItem>
                  {jobTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </>
      )}
    </Paper>
  );
};

export default JobFilter;
